const config = {
    base: {

    },
    dev: {
        apiUrl: 'http://localhost:9000/'
    },
    production: {
        apiUrl: '/.netlify/functions/'
    }
}

let envConfig = process.env.NODE_ENV === 'development' ? config.dev : config.production;
const realConfig = {...envConfig, ...config.base};

export default realConfig


// WEBPACK FOOTER //
// ./src/config.js